'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, VStack } from '@jaaq/hub-ui';
import { LayoutDashboard } from 'lucide-react';
import { useRouter } from 'next/navigation';
import type { ReactElement } from 'react';
import { OnboardingShell } from '#components/onboarding-shell';
import { clearOnboardingState } from '#lib/storage/clear-onboarding-state';
import { ActionCard } from './action-card';
export const SummaryStep = () => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading level={1} variant="display" tone="inverse">You’re all set!</Heading>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LayoutDashboard className="size-6 text-fg" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== router) {
    t2 = <OnboardingShell showProgress={false} showActions={false} centred={true}><VStack gap={8} className="max-w-200">{t0}<VStack gap={4}><ActionCard icon={t1} title="Go to hub" onClick={() => {
            clearOnboardingState();
            router.push("/hub");
          }} /></VStack></VStack></OnboardingShell>;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};